import BaseModel from './base';

class PaymentMethod extends BaseModel {
	async update({ priceId, currency, attachPaymentMethod = false }) {
		return this.put('', {
			body: {
				priceHandlerId: priceId,
				currency,
				attachPaymentMethod
			}
		});
	}

	/**
	 * Get payment method details saved in database.
	 */
	getById(paymentHandlerId) {
		return this.get(`/${paymentHandlerId}`);
	}

	/**
	 * Remove user payment method
	 */
	removePaymentMethod() {
		return this.delete('/');
	}
}

export default new PaymentMethod('/payment-method');
